var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"can_publish":_vm.can_publish,"published":_vm.published,"annotations_by_section":_vm.annotationsBySection,"getAnnotationCounts":_vm.getAnnotationCounts})],2)}
var staticRenderFns = []

export { render, staticRenderFns }